import createIcon from '../../createIcon';

/**
 * @component @name CurrencyPound
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMjEuMjVDMTUuOTMgMjEuMjUgMTcuNjIgMjAuMDggMTggMTguMjVMMTYuMjUgMTcuMzdDMTYgMTguNDYgMTUuMzMgMTkuMjUgMTQgMTkuMjVIOS4xQzkuOTMgMTguMjUgMTAuNiAxNi45MSAxMC42IDE1LjI1QzEwLjYgMTQuOSAxMC41NyAxNC41NiAxMC41MiAxNC4yNUgxNFYxMi4yNUg5LjgyQzkgMTAuNjcgOCA5Ljg1IDggOC4yNUM4IDYuMzIgOS41NyA0Ljc1IDExLjUgNC43NUMxMyA0Ljc1IDE0LjI5IDUuNyAxNC43OCA3LjAzTDE2LjYzIDYuMjVDMTUuODMgNC4yIDEzLjg0IDIuNzUgMTEuNSAyLjc1QzguNDYgMi43NSA2IDUuMjEgNiA4LjI1QzYgMTAuMDMgNi43OSAxMS4xNSA3LjQ5IDEyLjI1SDZWMTQuMjVIOC40N0M4LjU1IDE0LjU2IDguNiAxNC44OSA4LjYgMTUuMjVDOC42IDE3Ljk1IDYgMTkuMjUgNiAxOS4yNVYyMS4yNUgxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CurrencyPound = createIcon('CurrencyPound', [
  [
    'path',
    {
      d: 'M14 21.25C15.93 21.25 17.62 20.08 18 18.25L16.25 17.37C16 18.46 15.33 19.25 14 19.25H9.1C9.93 18.25 10.6 16.91 10.6 15.25C10.6 14.9 10.57 14.56 10.52 14.25H14V12.25H9.82C9 10.67 8 9.85 8 8.25C8 6.32 9.57 4.75 11.5 4.75C13 4.75 14.29 5.7 14.78 7.03L16.63 6.25C15.83 4.2 13.84 2.75 11.5 2.75C8.46 2.75 6 5.21 6 8.25C6 10.03 6.79 11.15 7.49 12.25H6V14.25H8.47C8.55 14.56 8.6 14.89 8.6 15.25C8.6 17.95 6 19.25 6 19.25V21.25H14Z',
      key: '4jvdx9',
    },
  ],
]);

export default CurrencyPound;
